var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-blob ma-n2 pa-2 d-flex",
    class: `align-${_vm.blob.text.valign || 'center'}`,
    style: {
      opacity: _vm.loadFontStatus.pending || !_vm.didRender ? 0 : 1
    }
  }, [_c('div', {
    ref: "text-readonly",
    staticClass: "renderable-text",
    class: {
      hide: _vm.isContentEditable && _vm.isSelected && !_vm.hasMultiSelected && (!_vm.indirectEdit || _vm.isFocused)
    },
    style: _vm.blob.text.css || {}
  }), _vm.isContentEditable ? _c('div', {
    key: _vm.isContentEditable,
    ref: "text-editable",
    staticClass: "absolute renderable-text",
    class: {
      'user-select-auto': _vm.isSelected || _vm.mode == 'view',
      hide: !_vm.isSelected || _vm.hasMultiSelected || _vm.indirectEdit && !_vm.isFocused
    },
    style: _vm.blob.text.css || {},
    attrs: {
      "contenteditable": "",
      "spellcheck": "false"
    },
    on: {
      "input": _vm.onInput,
      "focus": _vm.onFocusText,
      "blur": _vm.onBlurText,
      "paste": _vm.onPasteText,
      "keydown": _vm.onKeyDown,
      "dragstart": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm.isEditable && _vm.isSelected && !_vm.hasMultiSelected && _vm.indirectEdit && !_vm.isFocused ? _c('div', {
    staticClass: "text-blob-fill",
    on: {
      "mousedown": _vm.onClickStart,
      "mouseup": _vm.onClickEnd,
      "touchstart": _vm.onClickStart,
      "touchend": _vm.onClickEnd
    }
  }) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }